export const TOKEN_NAME = 'id_token'
export const USER_STORAGE = "user"